export default __webpack_public_path__ + "static/intro-39c85c9b98cc5a5ed7e97b7502f877af.jpg";